import { render } from "./UpdateGuildeline.vue?vue&type=template&id=40331169"
import script from "./UpdateGuildeline.vue?vue&type=script&lang=js"
export * from "./UpdateGuildeline.vue?vue&type=script&lang=js"

import "./UpdateGuildeline.vue?vue&type=style&index=0&id=40331169&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__